import * as Cookies from "js-cookie";

export default Cookies;


// WEBPACK FOOTER //
// ./src/browser/cookies.js